import React from 'react';
import { isIOS } from 'react-device-detect';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  useRouteMatch,
} from 'react-router-dom';
import StoreDirectory from './modules/landing_plaza';
import { store } from './modules/landing_plaza/store/store';

export const AppSelector = () => {
  const metaContent = isIOS
    ? 'width=device-width, initial-scale=1, maximum-scale=1'
    : 'width=device-width, initial-scale=1';
  return (
    <>
      <Helmet>
        <meta name="viewport" content={metaContent} />
      </Helmet>
      <Router basename={'/store'}>
        <LandingSelector />
      </Router>
    </>
  );
};

const LandingSelector = () => {
  const matched = useRouteMatch(['/details/:id/']);
  const idStoreWithCharater = matched?.params.id.match(/_s(\d+)/);
  const fallbackIDStore = matched?.params.id.match(/\d+/);
  const idStore = idStoreWithCharater
    ? idStoreWithCharater[1]
    : fallbackIDStore[0];

  return (
    <Route
      path={'*'}
      render={(props) =>
        matched && (
          <Provider store={store}>
            <StoreDirectory
              storeId={`${idStore}`}
              basename={matched.params.id}
            />
          </Provider>
        )
      }
    />
  );
};
